export default "__VITE_ASSET__635c1cb2__"